import { render, staticRenderFns } from "./pendingMedicalReport.vue?vue&type=template&id=4a19d657"
import script from "./pendingMedicalReport.vue?vue&type=script&lang=js"
export * from "./pendingMedicalReport.vue?vue&type=script&lang=js"
import style0 from "./pendingMedicalReport.vue?vue&type=style&index=0&id=4a19d657&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports